class PossibleAssignees {
  constructor(Authentication, EventCollection, ShiftUtils, Utils, shift, users) {
    Object.assign(this, { Authentication, EventCollection, ShiftUtils, Utils, shift, users });
    this.refresh();
  }

  refresh = () => {
    // we need to pass the same function reference here so we cannot pass an anonymous function expression
    this.Utils.evalAsyncOnce(this._refreshPossibleAssigneesOncePerDigest);
  };

  _refreshPossibleAssigneesOncePerDigest = () => {
    this.EventCollection.getEvents(
      this.shift.dtstart,
      this.Utils.addDays(this.shift.dtend, 1)
    ).then(() => {
      this.assignees = this._getAssignees();
    });
  };

  _mapAssignee(assignee, groupName) {
    const mapped = { ...assignee };
    mapped._assigneeGroup = groupName;

    return mapped;
  }

  _getAssignees() {
    let available = [];
    let unavailable = [];
    let forLocationPosition = [];
    let locationPositionSubtitle = '';
    let users = this.users;

    if (!this.Authentication.user.isAdmin) {
      users = users.filter((user) =>
        user.locationIds.some((userLocationId) => this.Authentication.user.locationIds.includes(userLocationId))
      );
    }

    if (this.shift.location || this.shift.position) {
      if (this.shift.position) {
        locationPositionSubtitle += this.shift.position.name;
      }

      if (this.shift.location) {
        if (locationPositionSubtitle) {
          locationPositionSubtitle += ' @ ';
        }

        locationPositionSubtitle += this.shift.location.name;
      }

      forLocationPosition = users.filter(
        (user) =>
          (!this.shift.location || user.locationIds.includes(this.shift.location.id)) &&
          (!this.shift.position || user.positionIds.includes(this.shift.position.id))
      );
    }

    if (this.shift.dtstart && this.shift.dtend && forLocationPosition.length) {
      available = forLocationPosition
        .filter((user) => this.ShiftUtils.isUserAvailable(user, this.shift))
        .map((user) => this._mapAssignee(user, `Available (${locationPositionSubtitle})`));

      unavailable = forLocationPosition
        .filter((user) => !this.ShiftUtils.isUserAvailable(user, this.shift))
        .map((user) => this._mapAssignee(user, `Unavailable (${locationPositionSubtitle})`));
    }

    const rest = users
      .filter(
        (user) =>
          !available.find((a) => a.id === user.id) && !unavailable.find((a) => a.id === user.id)
      )
      .map((user) => this._mapAssignee(user, 'Everyone'));

    return [...available, ...unavailable, ...rest];
  }

  assigneeGroupByOrder(group = '') {
    const firstLetter = group[0];
    const dict = {
      A: 1, // available first
      U: 2, // unavailable next
      E: 3, // rest (everyone) last
    };

    return dict[firstLetter] || 4;
  }
}

export default function PossibleAssigneesFactory(Authentication, EventCollection, ShiftUtils, Utils) {
  'ngInject';

  return class {
    constructor(shift, users) {
      return new PossibleAssignees(Authentication, EventCollection, ShiftUtils, Utils, shift, users);
    }
  };
}
